import actions from './actions'

const initialState = {
  id: '',
  name: '',
  role: '',
  role2: '',
  userName: '',
  email: '',
  avatar: '',
  authorized: false,
  loading: false,
  permissions: [], // Array of PermissionStatus objects with { slug, isGranted }
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE: {
      const newState = { ...state, ...action.payload }
      if (action.payload.permissions) {
        console.log('Reducer: Setting permissions to:', action.payload.permissions)
      }
      return newState
    }
    default:
      return state
  }
}
